<template>
  <div class="project">
    <div class="content">
      <div class="project-detail-nav"><span style="color: #999999;">混改项目></span>项目详情</div>
      <div>
        <div class="project-detail">
          <div class="project-right">
            <div class="project-title">
              {{assets.projectName}}
            </div>
            <div>
              <table>
                <tr>
                  <td class="td-label">挂牌价：</td>
                  <td colspan="5">
                    <span class="price" v-if="assets.projectPrice!='' && assets.projectPrice!=null && assets.projectPrice!=0">￥{{assets.projectPrice|priceFormat}}</span>
                    <span v-else-if="assets.projectPrice=='' || assets.projectPrice==null || assets.projectPrice==0">待定</span>
                    <span v-if="assets.projectPrice!='面议'&&assets.projectPrice!=''&&assets.projectPrice!=0">万元</span>
                  </td>
                </tr>
                <tr>
                  <td class="td-label">行业：</td>
                  <td v-if="assets.indutry_code == 'A'">农、林、牧、渔业</td>
                  <td v-else-if="assets.indutry_code == 'B'">采矿业</td>
                  <td v-else-if="assets.indutry_code == 'C'">制造业</td>
                  <td v-else-if="assets.indutry_code == 'D'">电力、热力、燃气及水生产和供应业</td>
                  <td v-else-if="assets.indutry_code == 'E'">建筑业</td>
                  <td v-else-if="assets.indutry_code == 'F'">批发和零售业</td>
                  <td v-else-if="assets.indutry_code == 'G'">交通运输、仓储和邮政业</td>
                  <td v-else-if="assets.indutry_code == 'H'">住宿和餐饮业</td>
                  <td v-else-if="assets.indutry_code == 'I'">信息传输、软件和信息技术服务业</td>
                  <td v-else-if="assets.indutry_code == 'J'">金融业</td>
                  <td v-else-if="assets.indutry_code == 'K'">房地产业</td>
                  <td v-else-if="assets.indutry_code == 'L'">租赁和商务服务业</td>
                  <td v-else-if="assets.indutry_code == 'M'">科学研究和技术服务业</td>
                  <td v-else-if="assets.indutry_code == 'N'">水利、环境和公共设施管理业</td>
                  <td v-else-if="assets.indutry_code == 'O'">居民服务、修理和其他服务业</td>
                  <td v-else-if="assets.indutry_code == 'P'">教育</td>
                  <td v-else-if="assets.indutry_code == 'Q'">卫生和社会工作</td>
                  <td v-else-if="assets.indutry_code == 'R'">文化、体育和娱乐业</td>
                  <td v-else-if="assets.indutry_code == 'S'">公共管理、社会保障和社会组织</td>
                  <td v-else></td>
                  <td class="td-label">类型：</td>
                  <td>{{assets.projectType}}</td>
                  <td class="td-label">发布时间：</td>
                  <td>{{assets.publishDate|dateFormat}}</td>
                </tr>
                <tr>
                  <td class="td-label">项目编号：</td>
                  <td>{{assets.projectCode}}</td>
                  <td class="td-label">组织机构：</td>
                  <td>{{assets.tradInstitutionName}}</td>
                  <td class="td-label">项目状态：</td>
                  <td v-if="assets.businessStatus == 'A01'">预披露</td>
                  <td v-else-if="assets.businessStatus=='A02'">正式披露</td>
                  <td v-else-if="assets.businessStatus == 'A05'">意向</td>
                  <td v-else-if="assets.businessStatus == 'A06'">成交</td>
                </tr>
              </table>
            </div>
            <div class="project-contacts">
              <i></i>
              <span style="margin-left:10px;font-weight:bold;">{{assets.contactor}}</span>
            </div>
          </div>
        </div>
        <div class="project-content">
          <div class="project-content-nav">
            <div class="active">
              项目基本情况
            </div>
          </div>
          <div class="project-content-info">
            <div v-html="assets.content">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  @import "../style/project-detail.css";
</style>

<script>
import { mapState } from 'vuex'
import global from '../components/public/Common.vue';

export default {
  name: 'author',
  computed: {
    // ...mapState({
    //   author: state => state.AuthorStore.author,
    //   other: state => state.AuthorStore.other,
    //   pathName: state => state.SelectStore.pathName
    // })
  },
  data() {
    return {
      projectDetailUrl:global.projectDetailUrl,
      assets: '',
    }
  },
  created: function () {
    let _this = this;

  },
  mounted:function(){
  let _this = this;
  $.ajax({
    url: _this.projectDetailUrl,
    type: 'post',
    dataType: 'jsonp',
    data: {
      //'id':'81895'
      'id':_this.$route.query.id,
      'orgid':global.orgid
    },
    success: function (data) {
      if (data.msg == 200) {
        _this.assets = data.result[0];
        //console.log(_this.assets);
      } else {
        alert(data.msg);
      }
    },
    error: function (data) {

    }
  });
  },
  watch: {
    //'$route': 'fetchData'
  },
  methods: {

  },
  filters: {
    dateFormat:function(time) {
      return global.dateFormatYmdhms(time)
    },
    priceFormat:function(price) {
      if (price.indexOf("-")!=0 && price.indexOf("-") != -1) {//区间金额
        var arr = price.split('-');
        return global.priceFormat(arr[0]) + '-' +global.priceFormat(arr[1])
      } else {
        return global.priceFormat(price)
      }
    }
  },
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/ProjectDetail.vue